import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
    errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { extendTrialRoute } from '../api/constant';
import { adminEmployersList, adminEnterprisesList } from '../constants';

type useExtendTrialProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useExtendTrial = ({
    setErrorText = () => { },
}: useExtendTrialProps) => {
    const client = useQueryClient();

    const { mutate: extendTrial, isLoading: isExtendTrialLoading } =
        useMutation({
            mutationFn: (variables: {
                company_id: number | string;
                trial_length: string
            }) =>
                axiosInstance
                    .post(extendTrialRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                client.invalidateQueries(adminEmployersList);
                client.invalidateQueries(adminEnterprisesList);
                setErrorText('');
            },
            onError: () => {
                setErrorText(errorMessage);
            },
        });

    return {
        extendTrial,
        isExtendTrialLoading,
    };
};
